import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppDropDown from "@toothfairy/shared-ui/AppDropDown";
import AppTextInput from "@toothfairy/shared-ui/AppTextInput";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React from "react";
import { useTranslation } from "react-i18next";
import { View } from "react-native";
import { Department } from "../../../../../models";

const QaPreselectionToolbar = ({
  searchBtnLabel = "Search",
  searchBtnAccLabel = "searchButton",
  handleSearch = () => {},
  searchTerm,
  setSearchTerm,
  agentType,
  setAgentType,
  agentDepartment,
  setAgentDepartment,
}) => {
  const { t } = useTranslation();
  const { currentTheme } = AppTheme?.useTheme();
  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        marginTop: -10,
        paddingHorizontal: 10,
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginTop: 10,
        }}
      >
        <AppTextInput
          value={searchTerm}
          onChangeText={setSearchTerm}
          style={{
            marginLeft: 5,
            minWidth: 320,
          }}
          placeholder={t("settings.toolbar.searchQaPreselection")}
          leftIcon={AppAssets.icons.search}
          iconColor={currentTheme?.theme?.grey}
        />
      </View>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginTop: 10,
        }}
      >
        <AppDropDown
          dropDownStyle={{
            width: 200,
            marginLeft: 5,
            borderColor: currentTheme?.theme?.border_color,
          }}
          isElevated={false}
          dropdownIconColor="transparent"
          items={[
            {
              name: t("settings.toolbar.allAgentTypes"),
              id: null,
            },
            {
              name: t("settings.toolbar.operator"),
              id: "retriever",
            },
            {
              name: t("settings.toolbar.orchestrator"),
              id: "planner",
            },
            {
              name: t("settings.toolbar.assistant"),
              id: "chatter",
            },
            {
              name: t("settings.toolbar.programmer"),
              id: "coder",
            },

            {
              name: t("settings.toolbar.voice"),
              id: "voice",
            },
          ]}
          propertyLabel="name"
          propertyValue="id"
          selectedValue={agentType}
          onValueChange={(itemValue, itemIndex) => {
            setAgentType(itemValue);
          }}
        />
        <AppDropDown
          dropDownStyle={{
            width: 200,
            marginLeft: 5,
            borderColor: currentTheme?.theme?.border_color,
          }}
          isElevated={false}
          dropdownIconColor="transparent"
          items={[
            {
              name: t("settings.toolbar.allDepartments"),
              id: null,
            },
            ...Object.values(Department).map((dept) => ({
              name: dept
                .toLowerCase()
                .replace(/_/g, " ")
                .replace(/\b\w/g, (c) => c.toUpperCase()),
              id: dept,
            })),
          ]}
          propertyLabel="name"
          propertyValue="id"
          selectedValue={agentDepartment}
          onValueChange={(itemValue, itemIndex) => {
            setAgentDepartment(itemValue);
          }}
        />
      </View>

      {/* <ToothFairyButton
        wrapperStyle={{ marginTop: 10 }}
        title={searchBtnLabel}
        accessibilityLabel={searchBtnAccLabel}
        onPress={() => handleSearch(labelText, valueText, agentType)}
      /> */}
    </View>
  );
};

export default QaPreselectionToolbar;
